import { HealthToGoRoot } from './HealthToGo.styles'
import { HealthToGoFlex, CopyColumn, ImageColumn, List, Header, CopyContainer } from './HealthToGo.styles'
import { useTranslation } from 'hooks/useTranslation'
import Image from 'next/image'
import playing from '../../../../../../../../public/assets/product-v2/freeze-dried-box/retriever-owner-sunshine.webp'
export const HealthToGo = () => {
  const { t } = useTranslation()

  return (
    <HealthToGoRoot>
      <HealthToGoFlex>
        <CopyColumn>
          <CopyContainer>
            <Header>{t('products-v2:freeze-dried-box.take-health-with-you.header')}</Header>
            <List>
              <li>{t('products-v2:freeze-dried-box.take-health-with-you.features.0')}</li>
              <li>{t('products-v2:freeze-dried-box.take-health-with-you.features.1')}</li>
              <li>{t('products-v2:freeze-dried-box.take-health-with-you.features.2')}</li>
            </List>
          </CopyContainer>
        </CopyColumn>
        <ImageColumn>
          <Image src={playing} alt={t('products-v2:freeze-dried-box.take-health-with-you.image')} />
        </ImageColumn>
      </HealthToGoFlex>
    </HealthToGoRoot>
  )
}

HealthToGo.displayName = 'HealthToGo'
